<template>
  <div class="container">
    <div style="margin: 10px 10px 10px 10px;">
      <el-row>
        <!-- tag搜尋欄 辦事成功的 tag-->
        <div class="col-md-8 offset-md-4"
        style="position: absolute;
        z-index: 2;
        bottom: 5px;">
          <el-tag
          style="margin: 5px;"
          v-for="tagName in selectedTags"
          size="small"
          type="primary"
          :key="tagName"
          :closable="true"
          :close-transition="false"
          @close="deleteSelectedTag(tagName)"
          >
            {{ tagName }}
          </el-tag>
        </div>
      </el-row>
      <el-row>
        <el-col :span="4">
          <el-button type="warning" @click="createShop">新增商店</el-button>
        </el-col>
        <el-col :span="3">
          <!-- <el-input placeholder="Search" v-model="filters[0].value"></el-input> -->
          <el-input
            placeholder="商店ID"
            v-model="searchKeyword"
            @keyup.enter.native="searchColumn"
          ></el-input>
        </el-col>
        <el-col :span="3">
          <!-- <el-input placeholder="Search" v-model="filters[0].value"></el-input> -->
          <el-input
            placeholder="商店名稱"
            v-model="searchKeywordName"
            @keyup.enter.native="searchColumn"
          ></el-input>
        </el-col>
        <el-col :span="3">
          <el-autocomplete
            placeholder="商店Tag"
            v-model="searchKeywordTags"
            :fetch-suggestions="getSuggestTags"
            @select="tagOnSelected"
            @keyup.enter.native="searchColumn"
            @keydown.delete.native="deleteSelectedTag('')"
          >
          </el-autocomplete>
        </el-col>
        <el-col :span="3">
          <!-- <el-input placeholder="Search" v-model="filters[0].value"></el-input> -->
          <el-input
            placeholder="SI名稱"
            v-model="searchKeywordSi"
            @keyup.enter.native="searchColumn"
          ></el-input>
        </el-col>
        <el-col :span="3">
          <!-- <el-input placeholder="Search" v-model="filters[0].value"></el-input> -->
          <el-input
            placeholder="EAA名稱"
            v-model="searchKeywordEaa"
            @keyup.enter.native="searchColumn"
          ></el-input>
        </el-col>
        <el-col :span="5">
          <!-- <el-button
            type="primary"
            icon="el-icon-search"
            @click="searchColumn"
            :disabled="!searchKeyword"
          ></el-button> -->
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="searchColumn"
          ></el-button>
          <el-button type="danger" @click="reset">重設</el-button>
        </el-col>
      </el-row>
    </div>

    <el-table :data="tableData" @sort-change="changeSort">
      <el-table-column
        label="商店ID"
        prop="accountId"
        sortable="custom"
        min-width="15px"
      >
        <template slot-scope="scope">{{ scope.row.accountId }}</template>
      </el-table-column>
      <el-table-column
        label="商店名稱"
        prop="name"
        sortable="custom"
        min-width="30px"
      >
        <template slot-scope="scope">
          {{ scope.row.name }}
          <br />
          <!-- 商店名稱下加上tag  by cockroach-->
          <el-tag
          style="margin: 1px;
          border-color: #b1b1b1;
          background-color: #ccc;"
          v-for="tagName in scope.row.tags"
          size="small"
          type="default"
          :key="tagName"
          :closable="true"
          :close-transition="false"
          @close="shopTagClose(scope.row.accountId, tagName, scope.row)"
          >
            {{ tagName }}
          </el-tag>
          <input
          style="margin: 1px;"
          type="text"
          placeholder="New Tag"
          class="form-control input-new-tag"
          v-model.lazy="newTagWords"
          @keyup.enter="newTagInput(scope.row.accountId, scope.row)"
          @blur="newTagInput(scope.row.accountId, scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="商店狀態"
        prop="isInitializedForSort"
        sortable="custom"
        min-width="30px"
      >
        <template slot-scope="scope">
          <el-popover placement="right" trigger="click">
            <el-radio-group
              v-model="scope.row.isInitialized.text"
              @change="changeInitailizedStatus(scope.row)"
            >
              <el-radio-button label="未上線"></el-radio-button>
              <el-radio-button label="已上線"></el-radio-button>
            </el-radio-group>

            <el-button size="small" slot="reference">{{
              scope.row.isInitialized.text
            }}</el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        label="所屬SI"
        prop="siAccountName"
        sortable="custom"
        min-width="20px"
      >
        <template slot-scope="scope">
          <el-popover placement="right" trigger="click">
            <el-select
              class="select-primary"
              size="large"
              placeholder="Single Select"
              v-model="scope.row.siAccountId"
              @change="selectChange(scope.row)"
              filterable
            >
              <el-option
                v-for="option in siAccounts"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="option.id"
              ></el-option>
            </el-select>
            <el-button size="small" slot="reference">{{
              scope.row.siAccountName
            }}</el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        label="所屬EAA"
        prop="name"
        sortable="custom"
        min-width="40px"
      >
        <template slot-scope="scope" v-if="scope.row.eaaAccountEmail"
          >{{ scope.row.eaaAccountName }} &lt;{{
            scope.row.eaaAccountEmail
          }}></template>
      </el-table-column>
      <el-table-column
        label="統編"
        prop="invoice"
        sortable="custom"
        min-width="30px"
      >
        <template slot-scope="scope">{{ scope.row.invoice }}</template>
      </el-table-column>
      <el-table-column label="Actions" min-width="40px">
        <template slot-scope="scope">
          <el-tooltip placement="top">
            <div slot="content">商店參數</div>
            <n-button
              type="info"
              size="sm"
              icon
              @click.native="clickInfo(scope.row)"
            >
              <i class="now-ui-icons users_single-02"></i>
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">修改商店設定</div>
            <n-button
              type="success"
              size="sm"
              icon
              @click.native="clickEdit(scope.row)"
            >
              <i class="now-ui-icons ui-2_settings-90"></i>
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">桌號QRCode管理</div>
            <n-button
              type="warn"
              size="sm"
              icon
              @click.native="clickQR(scope.row)"
            >
              <font-awesome-icon icon="qrcode" />
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">訂單推播群組設定</div>
            <n-button
              type="warning"
              size="sm"
              icon
              @click.native="lineNotifySetting(scope.row)"
            >
              <i class="now-ui-icons ui-1_bell-53"></i>
            </n-button>
          </el-tooltip>
          <!-- <el-tooltip placement="top">
            <div slot="content">前往訂單列表</div>
            <n-button type="primary" size="sm" icon @click.native="goToOrderList(scope.row)">
              <font-awesome-icon icon="receipt" />
            </n-button>
          </el-tooltip>-->
          <el-tooltip placement="top">
            <div slot="content">合約管理</div>
            <n-button
              type="primary"
              size="sm"
              icon
              @click.native="clickContract(scope.row)"
            >
              <font-awesome-icon icon="file-signature" />
            </n-button>
          </el-tooltip>
          <!-- <el-tooltip placement="top">
            <div slot="content">營業公休設定</div>
            <n-button
              type="default"
              style="background:#A25DDC;"
              size="sm"
              icon
              @click.native="openingSetting(scope.row)"
            >
              <i class="now-ui-icons ui-1_calendar-60"></i>
            </n-button>
          </el-tooltip> -->
          <el-tooltip placement="top">
            <div slot="content">外送條件設定</div>
            <n-button
              type="default"
              style="background:#f56042;"
              size="sm"
              icon
              @click.native="logisticsConf(scope.row)"
            >
              <i class="now-ui-icons shopping_delivery-fast"></i>
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">接單機使用者管理</div>
            <n-button
              type="danger"
              style="background:#BA0000;"
              size="sm"
              icon
              @click.native="showQcposUsers(scope.row)"
            >
              <font-awesome-icon icon="tablet-alt" />
            </n-button>
          </el-tooltip>
          <!-- <el-tooltip placement="top">
            <div slot="content">優惠活動設定</div>
            <n-button
              type="danger"
              style="background:#3b36ea;"
              size="sm"
              icon
              @click.native="promotions(scope.row)"
            >
              <font-awesome-icon icon="parachute-box" />
            </n-button>
          </el-tooltip> -->
          <!-- <el-tooltip placement="top">
            <div slot="content">串接設定與加值服務</div>
            <n-button
              type="danger"
              style="background:#386109;"
              size="sm"
              icon
              @click.native="middlewareSetting(scope.row)"
            >
              <i class="now-ui-icons business_globe"></i>
            </n-button>
          </el-tooltip> -->
          <el-tooltip placement="top">
            <div slot="content">寄送週報表</div>
            <n-button
              type="warn"
              style="background:#191970;"
              size="sm"
              icon
              @click.native="showSendReportDialog(scope.row)"
            >
              <i class="el-icon-message"></i>
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">發送商店資訊郵件</div>
            <n-button
              type="warning"
              size="sm"
              icon
              @click.native="sendEmail(scope.row)"
            >
              <i class="now-ui-icons ui-1_email-85"></i>
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">更新OA</div>
            <n-button
              type="warn"
              style="background:rgb(54, 209, 234);"
              size="sm"
              icon
              @click.native="updateOA(scope.row)"
            >
              <font-awesome-icon icon="people-arrows" />
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">停用舊帳號</div>
            <n-button
              type="warn"
              style="background:rgb(255, 0, 0);"
              size="sm"
              icon
              @click.native="stopOld(scope.row)"
            >
              <font-awesome-icon icon="theater-masks" />
            </n-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">訂單限流設定</div>
            <n-button
              type="warn"
              style="background:#6600cc;"
              size="sm"
              icon
              @click.native="orderLimit(scope.row)"
            >
              <font-awesome-icon icon="utensils" />
            </n-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分頁底部 -->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[15, 25, 50]"
      :page-size="pagesize"
      layout="total,jumper,prev, pager, next,sizes"
      :total="totalBiz"
    ></el-pagination>

    <el-dialog
      :title="'接單機介面 - 使用者管理｜' + dialogs.qcposUsers.shop.name"
      width="40%"
      :visible.sync="dialogs.qcposUsers.show"
    >
      <PosUserMngmt
        user-type="gaa"
        :shop-id="dialogs.qcposUsers.shop.accountId"
      />
    </el-dialog>

    <el-dialog
      :title="'寄送週報表｜' + dialogs.sendReport.shop.name"
      width="40%"
      :visible.sync="dialogs.sendReport.show"
    >
      <el-form label-position="right">
        <el-form-item label="查詢區間">
          <el-date-picker
            v-model="dialogs.sendReport.dateRange"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="～"
            start-placeholder="開始日期"
            end-placeholder="結束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="收件人（限一組，預設為店家Email）">
          <el-input
            placeholder="收件人"
            v-model="dialogs.sendReport.recipient"
          ></el-input>
        </el-form-item>
        <el-form-item label="密件副本（多組請以逗號分隔）">
          <el-input
            placeholder="密件副本"
            v-model="dialogs.sendReport.bccs"
          ></el-input>
        </el-form-item>
      </el-form>

      <br />
      <div class="d-flex justify-content-end">
        <el-button type="danger" round @click="sendWeeklyReport"
          >確定寄出</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Table, TableColumn, Select } from "element-ui";
import {
  fetchShopsByPage,
  fetchSiAccounts,
  fetchSuggestTags
} from "src/javascripts/gaa/fetchData";
import { assignToSpecificSiAccount } from "src/javascripts/gaa/updateData";
import {
  updateInitializedStatus,
  removeOld,
  addShopTag
} from "src/javascripts/gaa/postData";
import { deleteShopTag } from "src/javascripts/gaa/deleteData.js";
import PosUserMngmt from "src/pages/QcPos/PosUserMngmt";

import { library } from "@fortawesome/fontawesome-svg-core";
// import { faQrcode } from "@fortawesome/free-solid-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(fas);

import { DataTables, DataTablesServer } from "vue-data-tables";
import axios from "axios";
import moment from "moment";
import swal from "sweetalert2";

export default {
  components: {
    // [Table.name]: Table,
    // [TableColumn.name]: TableColumn,
    "font-awesome-icon": FontAwesomeIcon,
    DataTables,
    DataTablesServer,
    PosUserMngmt,
    [Select.name]: Select
  },
  beforeRouteEnter(to, from, next) {
    let params = {
      offset: 0,
      limit: 15,
      sort: "accountId:desc"
    };
    fetchShopsByPage(params)
      .then(res => {
        next(vm => vm.setData(res));
      })
      .catch(err => {
        console.log("err: ", err);
      });
  },
  data() {
    return {
      tableData: [],
      filters: [
        {
          prop: [
            "accountId",
            "name",
            "isInitializedForSort",
            "siAccountName",
            "invoice"
          ],
          value: ""
        }
      ],
      titles: [
        // {
        //   prop: "id",
        //   label: "商店ID"
        // },
        // {
        //   prop: "name",
        //   label: "商店名稱"
        // },
        // {
        //   prop: "siAccountName",
        //   label: "所屬SI"
        // }
        // {
        //   prop: "info",
        //   label: "Info"
        // }
      ],
      siAccounts: [],
      // tableProps: {
      //   defaultSort: {
      //     prop: "accountId",
      //     order: "descending"
      //   }
      // },

      dialogs: {
        qcposUsers: {
          show: false,
          shop: { id: -1, name: "" }
        },
        sendReport: {
          show: false,
          shop: { id: -1, name: "" },
          dateRange: [
            moment()
              .add(-1, "week")
              .startOf("isoWeek")
              .toDate(),
            moment()
              .add(-1, "week")
              .endOf("isoWeek")
              .toDate()
          ],
          recipient: "",
          bccs: ""
        }
      },
      pagesize: 15,
      currentPage: 1,
      totalBiz: 0,
      sortBy: "accountId:desc",
      searchKeyword: null,
      searchKeywordName: null,
      searchKeywordTags: null,
      searchKeywordSi: null,
      searchKeywordEaa: null,
      tagsSize: 5,
      suggestTags: [],
      selectedTags:[],
      newTagWords:'',
    };
  },
  created: function() {
    fetchSiAccounts()
      .then(res => {
        this.siAccounts = res.data;
      })
      .catch(err => {
        console.log("err: ", err);
      });
  },
  methods: {
    //分頁 初始頁currentPage、初始每頁數據數pagesize和數據testpage--->控制每頁幾條
    handleSizeChange: function(size) {
      this.pagesize = size;
      this.handleGetBizListApi();
      console.log("pagesize:" + this.pagesize);
      // console.log(this.handleGetBizListApi())
    },
    // 控制頁面的切換
    handleCurrentChange: function(currentPage) {
      this.currentPage = currentPage;
      // console.log('currentPage:' + currentPage);
      this.handleGetBizListApi();
    },
    //對所有數據進行分頁處理 發送請求
    handleGetBizListApi() {
      let queryStr = "";

      if (this.searchKeyword) {
        if (queryStr) queryStr += ",";
        queryStr += `a.id:${this.searchKeyword}`;
      }

      if (this.searchKeywordName) {
        if (queryStr) queryStr += ",";
        queryStr += `a.name:${this.searchKeywordName}`;
      }

      if (this.searchKeywordSi) {
        if (queryStr) queryStr += ",";
        queryStr += `sia.name:${this.searchKeywordSi}`;
      }

      if (this.searchKeywordEaa) {
        if (queryStr) queryStr += ",";
        queryStr += `eaa.name:${this.searchKeywordEaa}`;
      }

      let params = {
        offset: (this.currentPage - 1) * this.pagesize,
        limit: this.pagesize,
        sort: this.sortBy,
        query: queryStr,
        queryByTag: this.selectedTags.join(',') //以 tag 搜尋
        //query: this.searchKeyword
      };
      console.log("fetchShop: ", params);
      fetchShopsByPage(params)
        .then(res => {
          this.setData(res);
        })
        .catch(err => {
          console.log("err: ", err);
        });
    },
    searchColumn: function() {
      // console.log('-------- search ------');

      this.handleGetBizListApi();
    },
    reset: function() {
      this.sortBy = "accountId:desc";
      this.searchKeyword = null;
      this.searchKeywordName = null;
      this.searchKeywordSi = null;
      this.searchKeywordEaa = null;
      this.handleGetBizListApi();
    },
    changeSort: function(val) {
      // console.log('--------change sort ------', val);
      var order = null;
      if (val.order == "ascending") {
        order = "asc";
      } else if (val.order == "descending") {
        order = "desc";
      } else {
        return;
      }
      // a.id (商店ID)
      // a.name (商店名稱)
      // sia.name (SI名稱)
      // b.tax_id_number (統編)
      // eaa.name (EAA名稱)
      let sortKeyMap = {
        accountId: "a.id",
        name: "a.name",
        isInitializedForSort: "a_s.is_initialized",
        eaaAccountName: "eaa.name",
        invoice: "b.tax_id_number",
        siAccountName: "sia.name"
      };
      if (sortKeyMap[val.prop]) {
        this.sortBy = sortKeyMap[val.prop] + ":" + order;
        this.handleGetBizListApi();
      } else {
        console.log("sort " + val.prop);
      }
    },
    setData: function(res) {
      this.totalBiz = res.data.total;
      this.tableData = res.data.shops.map(d => {
        return {
          name: d.name,
          id: d.id,
          siAccountName: d.siAccountName ? d.siAccountName : "無",
          siAccountId: d.siAccountId,
          accountId: d.accountId,
          shopId: d.id,
          email: d.email,
          invoice: d.invoice,
          eaaAccountName: d.eaaAccountName,
          eaaAccountEmail: d.eaaAccountEmail,
          isInitialized: {
            text: d.isInitialized ? "已上線" : "未上線",
            value: d.isInitialized
          },
          isInitializedForSort: d.isInitialized ? "已上線" : "未上線",
          tags: d.tags ? d.tags.split(",") : null
        };
      });
    },
    clickInfo: function(row) {
      // this.$router.push({
      //   path: `/gaa/business/${row.id}/info`,
      //   query: { siAccountId: row.siAccountId }
      // });
      let routeUrl = this.$router.resolve({
        path: `/gaa/business/${row.id}/info`,
        query: { siAccountId: row.siAccountId }
      });
      window.open(routeUrl.href, "_blank");
      // this.$router.push({ path: `/gaa/business/${row.id}/info` });
    },
    clickEdit: function(row) {
      // this.$router.push({ path: `/gaa/business/${row.id}/edit` });
      let routeUrl = this.$router.resolve({
        path: `/gaa/business/${row.id}/edit`
      });
      window.open(routeUrl.href, "_blank");
    },
    clickDel: function() {
      console.log("del clicked!");
    },
    clickQR: function(row) {
      // this.$router.push({ path: `/gaa/business/${row.id}/qr` });
      let routeUrl = this.$router.resolve({
        path: `/gaa/business/${row.id}/qr`
      });
      window.open(routeUrl.href, "_blank");
    },
    lineNotifySetting: function(row) {
      let qs = `shop_id=${row.accountId}&shop_name=${encodeURIComponent(
        row.name
      )}`;
      // this.$router.push({
      //   path: `/line-notify-groups?${qs}`
      //   // path: `/line-notify-groups?shop_id=${row.accountId}&shop_name=${row.name}`
      // });
      let routeUrl = this.$router.resolve({
        path: `/line-notify-groups?${qs}`
      });
      window.open(routeUrl.href, "_blank");
    },
    openingSetting: function(row) {
      let qs = `shop_id=${row.accountId}&shop_name=${encodeURIComponent(
        row.name
      )}`;
      // this.$router.push({
      //   path: `/opening?${qs}`
      //   // path: `/line-notify-groups?shop_id=${row.accountId}&shop_name=${row.name}`
      // });
      let routeUrl = this.$router.resolve({ path: `/opening?${qs}` });
      window.open(routeUrl.href, "_blank");
    },
    middlewareSetting: function(row) {
      let qs = `shop_id=${row.accountId}&shop_name=${encodeURIComponent(
        row.name
      )}`;
      // this.$router.push({
      //   path: `/opening?${qs}`
      //   // path: `/line-notify-groups?shop_id=${row.accountId}&shop_name=${row.name}`
      // });
      let routeUrl = this.$router.resolve({ path: `/posmws?${qs}` });
      window.open(routeUrl.href, "_blank");
    },
    logisticsConf: function(row) {
      let qs = `shop_id=${row.accountId}&shop_name=${encodeURIComponent(
        row.name
      )}`;
      // this.$router.push({
      //   path: `/logistics?${qs}`
      //   // path: `/line-notify-groups?shop_id=${row.accountId}&shop_name=${row.name}`
      // });
      let routeUrl = this.$router.resolve({ path: `/logistics?${qs}` });
      window.open(routeUrl.href, "_blank");
    },
    goToOrderList(row) {
      // this.$router.push({ path: `/summary/orders?shopId=${row.accountId}` });
      let routeUrl = this.$router.resolve({
        path: `/summary/orders?shopId=${row.accountId}`
      });
      window.open(routeUrl.href, "_blank");
    },

    createShop() {
      // this.$router.push({ path: `/gaa/business/wizard` });
      let routeUrl = this.$router.resolve({ path: `/gaa/business/wizard` });
      window.open(routeUrl.href, "_blank");
    },
    selectChange(row) {
      // update si account id
      let updateData = {
        shopId: row.shopId,
        accountId: row.accountId,
        siAccountId: row.siAccountId
      };
      assignToSpecificSiAccount(updateData)
        .then(res => swal("所屬SI修改成功"))
        .catch(err => console.log(err));
    },
    clickContract(row) {
      // this.$router.push({
      //   path: `/gaa/business/${row.accountId}/contract?businessId=${row.id}`
      // });
      let routeUrl = this.$router.resolve({
        path: `/gaa/business/${row.accountId}/contract?businessId=${row.id}`
      });
      window.open(routeUrl.href, "_blank");
    },

    showQcposUsers(row) {
      this.dialogs.qcposUsers.show = true;
      this.dialogs.qcposUsers.shop = row;
    },
    promotions(row) {
      // this.$router.push({
      //   path: `/gaa/business/${row.id}/promotion`
      // });
      let routeUrl = this.$router.resolve({
        path: `/gaa/business/${row.id}/promotion`
      });
      window.open(routeUrl.href, "_blank");
    },
    orderLimit(row) {
      let routeUrl = this.$router.resolve({
        path: `/gaa/business/${row.accountId}/order-limits`
      });
      window.open(routeUrl.href, "_blank");
    },
    sendEmail: function(row) {
      // this.$router.push({
      //   path: `/account-email?shop_id=${row.accountId}&shop_name=${row.name}`
      // });
      let routeUrl = this.$router.resolve({
        path: `/account-email?shop_id=${row.accountId}&shop_name=${row.name}`
      });
      window.open(routeUrl.href, "_blank");
    },
    showSendReportDialog(row) {
      console.log("showSendReportDialog row data", row);
      this.dialogs.sendReport.shop = row;
      this.dialogs.sendReport.recipient = row.email;
      this.dialogs.sendReport.show = true;
    },
    sendWeeklyReport() {
      this.dialogs.sendReport.show = false;

      //FIXME: Check regex??
      let recipient = this.dialogs.sendReport.recipient;
      let bccs = this.dialogs.sendReport.bccs.split(",");
      bccs = bccs.map(bcc => bcc.trim());
      console.warn(`Will send to ${recipient}, BCC to ${JSON.stringify(bccs)}`);
      let from = moment(this.dialogs.sendReport.dateRange[0]).unix();
      let to = moment(this.dialogs.sendReport.dateRange[1]).unix();

      axios
        .post(
          `${process.env.VUE_APP_APIHOST}/gaa/report/${
            this.dialogs.sendReport.shop.accountId
          }/send-email`,
          {
            from,
            to,
            recipient,
            bccs
          }
        )
        .then(response => {
          console.log("sendWeeklyReport done", response.data);
          swal("報表稍後將寄出。");
        })
        .catch(err => {
          console.error("sendWeeklyReport error", err);
        });
    },
    changeInitailizedStatus(row) {
      row.isInitialized.value = !row.isInitialized.value;
      // update account_status
      updateInitializedStatus(row)
        .then(res => swal("成功"))
        .catch(err => swal("失敗"));
    },
    updateOA: function(row) {
      // this.$router.push({
      //   path: `/gaa/business/${row.id}/update-oa`,
      //   query: { siAccountId: row.siAccountId, type: 'catering' }
      // });
      let routeUrl = this.$router.resolve({
        path: `/gaa/business/${row.id}/update-oa`,
        query: { siAccountId: row.siAccountId, type: "catering" }
      });
      window.open(routeUrl.href, "_blank");
    },
    stopOld: function(row) {
      swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!"
        })
        .then(res => {
          if (res.value) {
            removeOld(row)
              .then(res => {
                this.$message({
                  type: "success",
                  message: `舊OA已轉換`
                });
              })
              .catch(err => {
                alert("ˋ轉換失敗");
                console.log(err);
              });
          } else {
            this.$message({
              type: "info",
              message: `操作取消`
            });
          }
        });
    },
    shopTagClose(shopId, tagName, row) {
      // 刪除單一店家的 tag
      let data = {
        shopId,
        tagName,
      }

      deleteShopTag(data)
      .then(res => {
        row.tags.splice( row.tags.indexOf(tagName), 1 );
      });
    },
    newTagInput(shopId, row){
      // 新增單一店家的 tag
      if (!this.newTagWords) return;
      let data = {
        shopId,
        tagName: this.newTagWords,
      }
      this.newTagWords = '';

      addShopTag(data)
      .then( res => {
        if (!row.tags) row.tags = [];
        row.tags.push(data.tagName);
        swal.fire('新增成功');
      })
      .catch(err => {
        console.log(err);
        swal.fire(err.data.error);
      });

    },
    async getSuggestTags(keyword, callback) {
      let params = {
        limit: 5,
        keyword,
      }

      let result = await fetchSuggestTags(params);
      let suggestTags = result.data
      for (let tag of suggestTags) {
        tag.value = tag.name;
        delete tag.name;
      }
      callback(suggestTags);
    },
    tagOnSelected(item) {
      if (this.selectedTags.includes(item.value)) return;
      this.selectedTags.push(item.value);
      this.searchKeywordTags = '';
    },
    deleteSelectedTag(tagName) {
      console.log(tagName);
      // 刪除選擇的 tag
      if (!tagName && this.searchKeywordTags) return;
      if (!tagName && !this.searchKeywordTags) {
        // 鍵盤刪除
        this.selectedTags.pop();
        return;
      }
      // 滑鼠點擊刪除
      this.selectedTags.splice( this.selectedTags.indexOf(tagName), 1);
    }
  }
};
</script>
